import App from "./Congress/App.svelte";

[...document.querySelectorAll("[data-congress]")].forEach((target) => {
    const data = JSON.parse(target.dataset.congress);
    new App({
        target,
        props: {
            congressId: parseInt(data.id),
            widgetView: data.view,
            links: data.links,
        },
    });
});
